import { Injectable } from '@angular/core';
import { EventReminder } from './event-reminder.model';
import { ApiCacheOptions } from 'src/app/shared/api/api-cache-options.model';
import { CommunicationApiService } from 'src/app/communication/shared/communication-api.service';

@Injectable({
  providedIn: 'root',
})
export class EventV4ReminderService {
  private _eventServiceBaseUrl: string = '/communication/v2/eventreminder/';
  private _cacheOptions: ApiCacheOptions;

  public constructor(private _communicationApiService: CommunicationApiService) {
    this._cacheOptions = this._communicationApiService.getDefaultApiCacheOptionsForNoCache();
  }

  public getReminder(draftMessageId?: number, messageId?: number): Promise<EventReminder> {
    const params: string[] = [];
    if (draftMessageId && draftMessageId > 0) {
      params.push(`draftMessageId=${draftMessageId}`);
    }
    if (messageId && messageId > 0) {
      params.push(`messageId=${messageId}`);
    }
    const query = params.length ? `?${params.join('&')}` : '';
    const url: string = `${this._eventServiceBaseUrl}reminder${query}`;
    return this._communicationApiService.get(url, this._cacheOptions);
  }

  public getRemindersForEvent(eventId: number): Promise<Array<EventReminder>> {
    const url: string = `${this._eventServiceBaseUrl}event/${eventId}/reminders`;
    return this._communicationApiService.get(url, this._cacheOptions);
  }

  public createReminder(reminder: EventReminder): Promise<number> {
    return this._communicationApiService.post(this._eventServiceBaseUrl, reminder);
  }

  public updateReminder(reminder: EventReminder): Promise<void> {
    return this._communicationApiService.put(this._eventServiceBaseUrl, reminder);
  }

  public deleteReminder(draftMessageId?: number, messageId?: number): Promise<void> {
    const params: string[] = [];
    if (draftMessageId && draftMessageId > 0) {
      params.push(`draftMessageId=${draftMessageId}`);
    }
    if (messageId && messageId > 0) {
      params.push(`messageId=${messageId}`);
    }
    const query = params.length ? `?${params.join('&')}` : '';
    const url: string = `${this._eventServiceBaseUrl}delete${query}`;
    return this._communicationApiService.delete(url);
  }
}
